import BuildingImage from "../../Assets/building2.svg";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBuilding } from "@fortawesome/free-solid-svg-icons";

import styles from "./Building.module.css";

const BuildingViewBuilding = ({ building, isSelected, onSelectBuilding }: any) => {
  return (
    <>
      <div
        className={"d-flex align-items-center "} // + isSelected ? styles.selectedBuilding : styles.building}
        style={{ verticalAlign: "middle" }}
        onClick={onSelectBuilding}
      >
        <img src={BuildingImage} alt={building.name} className="me-2" style={{ height: "4rem" }} />
        {/* <div style={{fontSize:'40px', display:"inline-block"}}>
          <FontAwesomeIcon icon={faBuilding} />
        </div> */}
        <span>{" " + building.name}</span>
      </div>
    </>
  );
};

export default BuildingViewBuilding;
